module.exports = __webpack_public_path__ + "media/images/steps/step_9-6e28f3606c003466b59f1e54f5928db5.svg";